exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap[data-v-3b9cbb03] {\n  max-width: 600px;\n  font-size: 18px;\n}\n.wait-text[data-v-3b9cbb03] {\n  font-weight: bold;\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b9cbb03","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/timer/RefundTimer.vue
// module id = PLNf
// module chunks = 1